<template>
  <v-layout row wrap class="mb-2 px-4 py-4">
    <h2 class="header  mb-2">Não é possível criar endosso para esta apólice</h2>
    <p>Confira quais foram as irregularidades em vermelho que impedem a criação: </p>
    <process-list-item
      v-for="(value, key) in validacoes"
      :key="`validacoes_${key}`"
      :process="{ text: validacoesLabel[key], status: value ? 'DONE' : 'ERRO' }"
    />
  </v-layout>
</template>

<script lang="js">
import _ from "lodash";
import { DONE, ERRO } from "@/components/Apolice/Steps/AutomaticApproval.js";
import ProcessListItem from "@/components/Apolice/Steps/ProcessListItem.vue";

const validacoesLabel = {
  corretor_lider: "Corretor líder",
  proposta_emitida: "Proposta emitida",
  proposta_vigente: "Proposta vigente",
  segurado_nao_blacklist: "Segurado com situação cadastral irregular",
  tomador_ccg_formalizado: "Tomador CCG formalizado",
  apolice_sem_cossegurado: "Apólice com cossegurado",
  tomador_nao_blacklist: "Tomador com situação cadastral irregular"
};

export default {
  name: "ProcessoSolicitacaoProposta",
  components: {
    ProcessListItem
  },
  props: {
    validacoes: {
      type: Object
    }
  },
  data: () => ({
    validacoesLabel
  }),
};
</script>



// WEBPACK FOOTER //
// ./src/components/ProblemasPermissaoEndossoModal.vue